<template>
  <div>
    <ClientOnly>
      <el-dialog
        v-model="isOpened"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        style="padding: 0 !important;"
        class ="login-component"
        destroy-on-close
        width="400px">
        <div :class="$style['form-content']">
          <div
            :class="$style['close_icon']"
            @click="close">
            <el-icon>
              <Close />
            </el-icon>
          </div>
          <LoginForm
            v-if="formType === FormType.login"
            @form-type-change="handleFormTypeChange" />
          <Forget
            v-else-if="formType === FormType.forget"
            @form-type-change="handleFormTypeChange" />
          <Register
            v-else-if="formType === FormType.register"
            @form-type-change="handleFormTypeChange" />
          <Bind
            v-else-if="formType === FormType.bind"
            @form-type-change="handleFormTypeChange" />
        </div>
      </el-dialog>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { FormType } from './constant'
import { Close } from '@element-plus/icons-vue'

// 异步组件导入
const Register = defineAsyncComponent(() => import('~/components/Login/components/register.vue'))
const Bind = defineAsyncComponent(() => import('~/components/Login/components/bind.vue'))
const Forget = defineAsyncComponent(() => import('~/components/Login/components/forget.vue'))
const LoginForm = defineAsyncComponent(() => import('~/components/Login/components/LoginForm.vue'))

// 响应式数据
const isOpened = ref(false)
const formType = ref(FormType.login)

// 表单类型切换处理
const handleFormTypeChange = (type: FormType) => {
  formType.value = type
}

// 关闭弹窗
const close = () => {
  isOpened.value = false
}

// 开启弹窗
const open = (opt?: any) => {
  isOpened.value = true
}

// 暴露方法给父组件
defineExpose({
  open,
  close
})
</script>

<style lang="less" module>
  .form-content {
    display: flex;
    background: #fff;
    width: max-content;
    min-width: 400px;
    min-height: 393px;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    box-sizing: border-box;
    padding: 35px 32px;
    position: relative;

    .close_icon {
      position: absolute;
      top: -20px;
      right: -38px;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #fff;
      cursor: pointer;

      i {
        color: #333;
        font-size: 20px;
      }
    }
  }
</style>

<style lang="less" scoped>
  .login-component {
    background: transparent;
    box-shadow: unset;

    .el-dialog {
    }

    .el-dialog__headerbtn {
      top: 48px;
      right: 16px;

      .el-icon-close {
        font-size: 20px;
      }
    }

    .el-dialog__body {
      padding: 0;
    }
  }
    // 弹框样式覆盖 - 确保在所有环境下padding都为0
    :deep(.el-dialog) {
      padding: 0 !important;
      .el-dialog__body {
        padding: 0 !important;
      }
      .el-dialog__header {
        padding: 0!important;
      }
      .el-dialog__footer {
        padding: 0 !important;
      }
    }
</style>
